import { v4 as uuidV4 } from 'uuid';

export const uuid = () => uuidV4();

export const sleep = (delay = 0) => {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
};
